/* src/app/shared/garmin-circles/garmin-circles.component.scss */
#garmin {
  position: relative;
}
.circle:nth-child(1) {
  bottom: 0vw;
}
.circle:nth-child(2) {
  bottom: 13vw;
  left: 22vw;
  z-index: 1;
}
.circle:nth-child(3) {
  bottom: 0vw;
  left: 43vw;
}
.blue {
  background-size: 100% 100%;
  width: 28.75vw;
  height: 28.75vw;
  position: absolute;
  top: 0.35vw;
  left: 0.35vw;
  border-radius: 50%;
  background:
    linear-gradient(
      180deg,
      #2cdbf1 0%,
      #0070d8 100%);
}
.inner {
  border-radius: 50%;
  position: absolute;
  width: 27.6vw;
  height: 27.6vw;
  top: 0.5vw;
  left: 0.5vw;
  background:
    linear-gradient(
      180deg,
      rgb(38, 38, 38) 0%,
      rgb(32, 32, 32) 47%,
      rgb(61, 61, 61) 100%);
}
.orange {
  background-size: 100% 100%;
  width: 28.75vw;
  height: 28.75vw;
  position: absolute;
  top: 0.35vw;
  left: 0.35vw;
  border-radius: 50%;
  background:
    linear-gradient(
      180deg,
      #FF8C00 0%,
      #FFA500 100%);
}
.green {
  background-size: 100% 100%;
  width: 28.75vw;
  height: 28.75vw;
  position: absolute;
  top: 0.35vw;
  left: 0.35vw;
  border-radius: 50%;
  background:
    linear-gradient(
      180deg,
      #3CB371 0%,
      #7FFF00 100%);
}
.circle {
  background: black;
  color: white;
  text-align: center;
  border-radius: 50%;
  width: 30vw;
  height: 30vw;
  position: absolute;
  margin: 1vw;
  border: 0.3vw solid rgb(61, 61, 61);
  background: rgb(38, 38, 38);
  background:
    linear-gradient(
      180deg,
      rgb(38, 38, 38) 0%,
      rgb(32, 32, 32) 47%,
      rgb(61, 61, 61) 100%);
}
.circleTitle {
  margin-top: 30%;
  font-size: x-large;
  padding: 0px;
  margin-bottom: 0px;
}
.circleSubtitle {
  font-size: small;
  margin-top: 1vw;
  font-weight: 300;
}
/*# sourceMappingURL=garmin-circles.component.css.map */
